export function imprimirImagem({ url, nome }) {
  const janela = window.open('', '_blank');
  if (!janela) {
    window.alert('Permita abrir novas janelas para imprimir a imagem.');
    return;
  }
  janela.opener = null;
  const documento = janela.document;
  documento.title = nome || 'Imprimir imagem';
  documento.documentElement.lang = 'pt-BR';
  const estilo = documento.createElement('style');
  estilo.textContent = `
    @page { size: A4; margin: 10mm; }
    body { margin: 0; padding: 20px; background: #f8fafc; text-align: center; }
    img { display: block; max-width: 100%; height: auto; margin: 0 auto; }
    @media print {
      body { padding: 0; background: white; }
      img { width: auto; max-width: 100%; max-height: 270mm; break-inside: avoid; }
    }
  `;
  documento.head.appendChild(estilo);
  const imagem = documento.createElement('img');
  imagem.alt = nome || 'Imagem anexada';
  imagem.addEventListener('load', () => {
    janela.requestAnimationFrame(() => janela.requestAnimationFrame(() => {
      if (janela.closed) return;
      janela.focus();
      janela.print();
    }));
  }, { once: true });
  imagem.addEventListener('error', () => {
    janela.close();
    window.alert('Não foi possível carregar a imagem para impressão. Tente novamente.');
  }, { once: true });
  documento.body.appendChild(imagem);
  imagem.src = url;
}
